module.exports = __webpack_public_path__ + "img/gold1.4adf5ac8.png";